<template>
    <div
        class="ppv2-inline-flex ppv2-items-center ppv2-rounded-xl ppv2-transition-all ppv2-shadow-lg ppv2-overflow-hidden ppv2-min-h-[40px]"
        :class="variantClasses"
    >
        <!-- Primary Action -->
        <button
            @click.stop="$emit('click')"
            class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-px-6 ppv2-h-full ppv2-transition-all !ppv2-text-white"
            type="button"
        >
            <slot name="icon">
                <component :is="icon" :size="iconSize" v-if="icon" />
            </slot>
            <span class="poppinsRegular ppv2-text-sm">
                <slot>{{ label }}</slot>
            </span>
        </button>

        <!-- Vertical separator -->
        <div class="ppv2-w-[1px] ppv2-h-[40px] ppv2-bg-white"></div>

        <!-- Dropdown Trigger -->
        <button
            @click.stop="$emit('toggle')"
            class="ppv2-flex ppv2-items-center ppv2-justify-center ppv2-px-4 ppv2-h-full ppv2-transition-all !ppv2-text-white"
            type="button"
        >
            <ChevronDown
                :size="iconSize"
                :class="{ 'ppv2-rotate-180': showDropdown }"
                class="ppv2-transition-transform ppv2-duration-200"
            />
        </button>
    </div>
</template>

<script>
import { ChevronDown } from 'lucide-vue'

export default {
    name: 'BaseSplitButton',
    components: {
        ChevronDown,
    },
    props: {
        label: {
            type: String,
            default: '',
        },
        icon: {
            type: [Object, String, Function],
            default: null,
        },
        iconSize: {
            type: Number,
            default: 17,
        },
        showDropdown: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: 'primary',
        },
    },
    computed: {
        variantClasses() {
            if (this.variant === 'primary') {
                return 'ppv2-bg-[#7D2DBD] ppv2-text-white'
            }
            return ''
        },
    },
}
</script>

<style scoped>
button {
    border: none;
    background: transparent;
    cursor: pointer;
    outline: none;
}
</style>
